// import "videojs-youtube";

(function () {
  const videoContainer = document.querySelectorAll('.video-container');

  videoContainer.forEach((vc) => {
    const vButton = vc.querySelector('[data-video-button]');
    const vFrame = vc.querySelector('iframe');
    const vCover = vc.querySelector('.video-cover');
    const iFrameurl = vc.querySelector('.iframeurl');
    if (iFrameurl) {
      const embedUrl = iFrameurl.getAttribute('iframeUrl');
      const videoId = embedUrl.match(/embed\/([A-Za-z0-9_-]{11})/)[1];
      vCover.style.backgroundImage = `url(https://i.ytimg.com/vi_webp/${videoId}/sddefault.webp)`;
    }

    if (vButton) {
      vButton.onclick = (e) => {
        e.preventDefault();

        setTimeout(() => {
          vCover.classList.add('hidden');
        }, 700);
        vc.classList.add('on');
        if (vFrame.src != '') {
          let autoPlay = vFrame.src + '?autoplay=1';
          vFrame.src = autoPlay;
        } else {
          let autoPlay =
            document.getElementById('iframeSrc').getAttribute('iframeUrl') +
            '?autoplay=1';
          vFrame.src = autoPlay;
        }
      };
    }
  });

  //     popon = document.getElementById("modalbox");
  //     const vbuttons = document.querySelectorAll('[data-video-button]');
  //     vbuttons.forEach((b) => {
  //         console.log(b.getAttribute('data-video-button'));
  //         b.onclick = function(e){
  //             e.preventDefault();
  //             popon.style.display = "flex";
  //             document.getElementById("video").src = b.getAttribute('data-video-button');
  //         }
  //     })
  //     popon.onclick = function(){
  //         popon.style.display = "none";
  //     }
  //     // window.onload = function(){
  //     //     document.onclick = function(e){
  //     //       if(e.target.id !== popon){
  //     //         popon.style.display = 'none';
  //     //       }
  //     //     };
  //     //   };

  // //     window.onclick = function (e){
  // // console.log(e.target);
  // //         setTimeout(() => {
  // //             if(popon.style.display == 'block'){
  // //                 popon.style.display = "none";
  // //             } else { console.log('end');}
  // //         }, 1000);

  // //         }
})();
